import React from 'react'
import * as priceListActions from 'actions/priceLists'
import { features } from 'helpers/constants'
import {t} from "helpers/language"

const isPricingTabSelected = document.getElementsByClassName("active tabs-pricing").length !== 0

export const skill = {
  key: "PART_PRICING",
  group: 'pricelists',
  label: t("Use complex pricing"),
  desc: t("Use price breaks, base price, minimum price and other advanced features to price your parts"),
  feature: features.COMPLEX_PRICING,
  steps: [
    {
      target: '.partPivotTable-pivot-table',
      content: <div>To begin, open a part by clicking on it in the list</div>,
      location: '/price-lists',
      action: () => priceListActions.selectAllPriceLists(),
      skip: () => !!window.location.href.match(/.+\/price-lists\/parts\/[0-9]+/gi),
    },
    {
      target: '.tabs-tabHeader-vertical.tabs-pricing',
      content: <div>To configure the price of this part, <i>Select the Pricing tab</i></div>,
      skip: () => isPricingTabSelected,
    },
    {
      target: '.part-pack-price-breaks-pivot-table-container',
      content: <div>Here, we can specify a different price depending on how many of this part someone buys. Add a new price break by adding a new row with a <i>Min of 5</i> and a <i>Markup of 40%</i></div>,
      actions: [
        {
          label: 'Next',
          primary: true,
          flat: true,
          type: 'next',
        },
      ],
    },
    {
      target: '.part-pack-editor-base-price.section',
      content: <div>A base price is always added on top of the price being charged to the customer. A minimum price ensures the price never drops below a certain value. <i>Select Apply a Minimum Price by clicking on the drop-down, then enter a minimum price of 20.00</i><br/><br/></div>,
      actions: [
        {
          label: "Learn More Skills",
          flat: true,
          type: 'skills',
        },
        {
          label: 'Finish',
          primary: true,
          type: 'finish',
        },
      ],
    },
  ],
}

export default skill
